import React, { FC, Children, cloneElement } from 'react';
import injectSheet from 'react-jss';
import { handleAccessibilityClick } from 'Utils/handleAccessibilityClick';
import styleSheet from './styles';

interface Props {
  classes?: any;
  id?: string;
  onClick?: (event: object) => void;
  value?: string;
  isChecked: boolean;
  children?: React.LabelHTMLAttributes<HTMLLabelElement>;
  // eslint-disable-next-line react/no-unused-prop-types
  selectedColor?: string;
}

const RadioButton: FC<Props> = (props: Props) => {
  const { classes, id, onClick, value, isChecked, children } = props;

  const labelChild = Children.map(children, (child: any) => {
    // Business logic enhances label with styles, nothing functional //
    let fontColor;
    let activeColor;

    if ((child.props.style && child.props.style.color) || !child.className)
      fontColor = child && child.props.style && child.props.style.color;

    if (child.props['active-color'])
      // using this data-attr to set an active color for the label, didn't want to create a label component that we'd have to import with the RadioButton always to create a label //
      activeColor = child.props['active-color'];

    const styles = {
      ...child.style,
      // Sets the padding to the child label//
      paddingLeft: '28px',
      color: isChecked ? activeColor : fontColor,
    };

    // Clone child and inject styles //
    return cloneElement(child, {
      htmlFor: id,
      style: styles,
    });
  });

  const onKeyDown = (event: object) => {
    if (handleAccessibilityClick(event)) {
      onClick({ target: { value, id } });
    }
  };

  return (
    <div
      className={classes.radioButton}
      onKeyDown={onKeyDown}
      tabIndex={0}
      role="radio"
      aria-checked={isChecked}
      data-testid={`RadioButton${value}`}
    >
      <input
        id={id}
        onChange={onClick}
        value={value}
        type="radio"
        checked={isChecked}
        data-testid={value}
      />
      {(children && labelChild) || <label htmlFor={id}>{null}</label>}
    </div>
  );
};

RadioButton.defaultProps = {
  classes: {},
  id: undefined,
  onClick: () => {},
  value: undefined,
  children: undefined,
  selectedColor: undefined,
};

export default injectSheet(styleSheet)(RadioButton);
